import { render, staticRenderFns } from "./BusiestInstallations.vue?vue&type=template&id=b509a57a&"
import script from "./BusiestInstallations.vue?vue&type=script&lang=js&"
export * from "./BusiestInstallations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports